import React, { useEffect, useState } from "react"
import { Col, Row, Modal, Alert } from "reactstrap"

import Loader from "react-loader-spinner"

// availity-reactstrap-validation
import {
  AvForm,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation"

const UpdateStaffModal = props => {
  const [modal, setmodal] = useState(props.show)
  const [error, setError] = useState(props.error)
  const [isLoading, setIsLoading] = useState(props.isLoading)
  const [staffInfo, setStaffInfo] = useState(props.individualStaff)
  const [permissions, setPermissions] = useState([])
  const [success, setSuccess] = useState(props.success)

  useEffect(() => {
    setStaffInfo(props.individualStaff)
    var staffPerms = []
    props.individualStaff.permissions.forEach(perm => {
      staffPerms.push(perm.name)
    })
    setPermissions(staffPerms)
  }, [props.individualStaff])

  const departmentOptions = props.departments.map((dept, index) => (
    <option key={index} value={dept.id}>
      {dept.name}
    </option>
  ))

  const positionOptions = props.positions.map((pos, index) => (
    <option key={index} value={pos.id}>
      {pos.name}
    </option>
  ))

  const permissionOptions = props.permissions.map((perm, index) => (
    <AvCheckbox key={index} customInput label={perm.name} value={perm.name} />
  ))

  useEffect(() => {
    setError(props.error)
  }, [props.error])

  useEffect(() => {
    setmodal(props.show)
  }, [props.show])

  useEffect(() => {
    setIsLoading(props.isLoading)
  }, [isLoading])

  useEffect(() => {
    setSuccess(props.success)
  }, [props.success])

  function toggle() {
    if (modal) {
      props.onHide()
    }
    setmodal(!modal)
    removeBodyCss()
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  function handleSubmit(values) {
    setIsLoading(true)

    props.handleSubmit(values)
  }

  return (
    <Modal
      size="xl"
      isOpen={modal}
      toggle={() => {
        toggle()
      }}
      scrollable={true}
    >
      <div className="modal-header">
        <h3 className="modal-title" id="staticBackdropLabel">
          Update Staff
        </h3>

        <button
          type="button"
          className="btn-close"
          onClick={() => {
            props.onHide()
            setmodal(false)
          }}
          aria-label="Close"
        ></button>
      </div>
      <AvForm
        className="mt-4"
        onValidSubmit={(e, v) => {
          handleSubmit(v)
        }}
      >
        <div className="modal-body">
          <div
            style={{
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "center",
            }}
          >
            {isLoading ? (
              <Loader
                type="ThreeDots"
                color="#2BAD60"
                height="20"
                width="100"
              />
            ) : (
              ""
            )}
          </div>
          {error ? <Alert color="danger">{props.error}</Alert> : null}
          {success ? <Alert color="success">{success}</Alert> : null}
          <div className="p-2">
            <Row>
              <Col md="4">
                <div className="mb-3">
                  <AvField
                    value={staffInfo.first_name}
                    name="first_name"
                    label="First Name"
                    type="text"
                    required
                    placeholder="Enter first Name"
                  />
                </div>
              </Col>

              <Col md="4">
                <div className="mb-3">
                  <AvField
                    value={staffInfo.last_name}
                    name="last_name"
                    label="Last Name"
                    type="text"
                    required
                    placeholder="Enter Last Name"
                  />
                </div>
              </Col>
              <Col md="4">
                <div className="mb-3">
                  <AvField
                    value={staffInfo.other_name}
                    name="other_name"
                    label="Other Names"
                    type="text"
                    placeholder="Enter other Names"
                  />
                  <AvField
                    value={staffInfo.other_name}
                    name="id"
                    value={staffInfo.id}
                    type="hidden"
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <div className="mb-3">
                  <AvField
                    value={staffInfo.telephone}
                    name="telephone"
                    label="Phone"
                    type="phone"
                    validate={{
                      required: { value: true },
                      maxLength: {
                        value: 10,
                        errorMessage: "Enter a 10 digit phone number.",
                      },
                      minLength: {
                        value: 10,
                        errorMessage: "Enter a 10 digit phone number.",
                      },
                    }}
                    placeholder="Enter Phone Number"
                  />
                </div>
              </Col>

              <Col md="6">
                <div className="mb-3">
                  <AvField
                    value={staffInfo.email}
                    id="email"
                    name="email"
                    label="Email"
                    className="form-control"
                    placeholder="Enter email"
                    type="email"
                    required
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <div className="mb-3">
                  <AvField
                    type="select"
                    name="department_id"
                    label="Select Department"
                    required
                    value={staffInfo.department_id}
                  >
                    <option value="">--select--</option>
                    {departmentOptions}
                  </AvField>
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3">
                  <AvField
                    type="select"
                    name="position_id"
                    label="Select Position"
                    required
                    value={staffInfo.position_id}
                  >
                    <option value="">--select--</option>
                    {positionOptions}
                  </AvField>
                </div>
              </Col>
            </Row>

            <Row>
              <Col>
                <div className="mb-3">
                  <AvCheckboxGroup
                    inline
                    name="permissions"
                    label="Select Permissions"
                    required
                    value={permissions}
                  >
                    {permissionOptions}
                  </AvCheckboxGroup>
                </div>
              </Col>
            </Row>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-light"
            onClick={() => {
              props.onHide()
              setmodal(false)
            }}
          >
            Close
          </button>
          <button
            onClick={() => {
              // props.onHide()
              // setmodal(false)
            }}
            type="submit"
            className="btn btn-primary"
            disabled={isLoading}
          >
            Update Details
          </button>
        </div>
      </AvForm>
    </Modal>
  )
}

export default UpdateStaffModal
